import path from 'path';
import { BookFlipType } from 'constants/flipTypes';

export const replaceBookPage = ({ page, pageUrl, str }) => {
  str = str.replace('position: relative;', '');
  str = str.replace('style="overflow', 'class="page" style="overflow');
  str = str.replace('width: 831px; height: 1156px;', '');
  str = str.replace('data="', 'data=' + pageUrl);
  str = str.replace(
    '<svg',
    '<svg id="' + page.bookId + '-' + page.pageIndex + '"'
  );
  str = str.replace('<html lang="en">', '<html lang="zh-Hant-TW">');
  str = str.replace(/fonts\//g, pageUrl + 'fonts/');
  str = str.replace(
    'image { pointer-events: none; }',
    'image { pointer-events: auto; }'
  );
  str = str.replace('src="', 'src="' + pageUrl);
  const xlink =
    'xlink:href="' + path.basename(page.html, path.extname(page.html));
  const reg = new RegExp(xlink, 'g');
  str = str.replace(
    reg,
    'xlink:href="' + pageUrl + path.basename(page.html, path.extname(page.html))
  );
  return {
    ...page,
    svg: str
  };
};

// 依當下頁碼推導所屬冊別（課本/習作/放大…）與 GA 用的 book_section
// catalog 為 catalog.json content.books 陣列，每個 book 帶 bookName 與 sections[].pages[].src
// src 檔名（basename - 1）為全域 0-based 單頁索引、跨冊連號，取「起始頁 <= 當前單頁的最大者」即為所屬冊
export const getBookSection = ({ catalog, pageIndex, isDoublePageMode }) => {
  if (!Array.isArray(catalog) || catalog.length === 0) {
    return { section: 'other', bookName: '' };
  }
  const singlePageIndex = isDoublePageMode ? pageIndex * 2 : pageIndex;
  let picked = null;
  for (const book of catalog) {
    const firstPage =
      book.sections && book.sections[0] && book.sections[0].pages && book.sections[0].pages[0];
    if (!firstPage || !firstPage.src) continue;
    const startPage = parseInt(path.basename(firstPage.src, path.extname(firstPage.src)), 10) - 1;
    if (Number.isNaN(startPage)) continue;
    if (startPage <= singlePageIndex && (!picked || startPage > picked.startPage)) {
      picked = { startPage, bookName: book.bookName };
    }
  }
  const bookName = (picked && picked.bookName) || '';
  // 先比習作（含「習作放大」）再比課本/放大，避免「習作放大」被誤判為 textbook
  const section = /習作/.test(bookName)
    ? 'workbook'
    : /課本|課放大|放大/.test(bookName)
      ? 'textbook'
      : 'other';
  return { section, bookName };
};

export const groupPages = (pages, isDoublePageMode) => {
  if (isDoublePageMode) {
    let groupedPages = {};
    for (let index in pages) {
      const newIndex = Math.floor(index / 2);
      if (Array.isArray(groupedPages[newIndex])) {
        groupedPages[newIndex].push(pages[index]);
      } else {
        groupedPages[newIndex] = [pages[index]];
      }
    }
    return groupedPages;
  } else {
    let groupedPages = {};
    for (let index in pages) {
      groupedPages[index] = [pages[index]];
    }
    return groupedPages;
  }
};

export const preserveSVGAspectRatio = ({
  svg,
  width,
  height,
  LRFlip,
  pageInfos,
  pageIndex,
  isDoublePageMode
}) => {
  svg = svg.replace(`width="${width}"`, 'width="100%"');
  svg = svg.replace(`height="${height}"`, 'height="100%"');
  // 2. 移除 xlink 命名空間（避免警告）
  svg = svg.replace(/xmlns:xlink="[^"]*"/g, '');

  // 3. 把所有 xlink:href 換成 href
  svg = svg.replace(/xlink:href=/g, 'href=');
  if (isDoublePageMode) {
    const isEven = pageIndex % 2 === 0;
    if (
      pageInfos &&
      pageIndex === pageInfos.length - 1 &&
      pageInfos.length % 2 === 1
    ) {
      svg = svg.replace('<svg', '<svg preserveAspectRatio="xMidYMid"');
    } else {
      if (
        (isEven && LRFlip === BookFlipType.LEFT_TO_RIGHT) ||
        (!isEven && LRFlip === BookFlipType.RIGHT_TO_LEFT)
      ) {
        svg = svg.replace('<svg', '<svg preserveAspectRatio="xMaxYMid"');
      } else {
        svg = svg.replace('<svg', '<svg preserveAspectRatio="xMinYMid"');
      }
    }
  } else {
    svg = svg.replace('<svg', '<svg preserveAspectRatio="xMidYMid"');
  }
  return svg;
};
